import { render, staticRenderFns } from "./CharityInvolvementVolunteering.vue?vue&type=template&id=63dd98fa"
import script from "./CharityInvolvementVolunteering.vue?vue&type=script&lang=js"
export * from "./CharityInvolvementVolunteering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports